// extracted by mini-css-extract-plugin
export default {"skeleton":"UTFMZ","loading":"ZpHnB"};